import type { EditableFloorPlan } from '../models/editor-feature';
import type { FloorPlanDraft } from '../services/floorplan-editor.service';
import { withOnlyDeskShapes } from './desk-shape-outliers';
import { normalizeFloorPlan, type StoredFloorPlan } from './normalize-floorplan';

/**
 * The plan as its draft has it: the draft's layers and scale over the live plan's identity.
 *
 * The live plan's id, office, storey and timestamp are kept, because those are what saving and
 * publishing are checked against; everything drawn comes from the draft.
 */
export const withDraft = (stored: StoredFloorPlan, draft: FloorPlanDraft): EditableFloorPlan => {
  const { payload } = draft;

  return withOnlyDeskShapes(normalizeFloorPlan({
    ...stored,
    borderLayer: payload.borderLayer ?? stored.borderLayer,
    floorLayer: payload.floorLayer ?? stored.floorLayer,
    roomLayer: payload.roomLayer ?? stored.roomLayer,
    workplacesLayer: payload.workplacesLayer ?? stored.workplacesLayer,
    labelLayer: payload.labelLayer ?? stored.labelLayer,
    unitsPerMetre: payload.unitsPerMetre ?? stored.unitsPerMetre,
  }));
};

export default withDraft;
